import React from 'react';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { FormField, AVCheckOptions } from '../../types/form';

interface AVCheckFieldEditorProps {
  editedField: FormField;
  onFieldChange: (updates: Partial<FormField>) => void;
}

export const AVCheckFieldEditor: React.FC<AVCheckFieldEditorProps> = ({
  editedField,
  onFieldChange,
}) => {
  const options = (editedField.options || {}) as AVCheckOptions;
  // Default to requiring both when unset.
  const requireBoth = options.requireBoth !== false;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between rounded-lg border border-input p-3">
        <div className="space-y-0.5">
          <Label htmlFor={`requireBoth-${editedField.id}`}>Require both camera and microphone</Label>
          <p className="text-xs text-muted-foreground">
            When on, both the camera and microphone must pass for the check to succeed.
          </p>
        </div>
        <Switch
          id={`requireBoth-${editedField.id}`}
          checked={requireBoth}
          onCheckedChange={(checked) =>
            onFieldChange({
              options: { ...editedField.options, requireBoth: checked },
            })
          }
        />
      </div>
    </div>
  );
};
